import { gql, useLazyQuery, useMutation, useQuery } from '@apollo/client'
import { Source } from '@ui/__generated__/graphql'

const GetSourcesQL = gql(`
  query GetSources {
    sources {
      id
      name
      type
      apiKey
    }
  }
`)

const GetSourceQL = gql(`
  query GetSource($input: FindByIdInput!) {
    source(input: $input) {
      id
      name
      type
      apiKey
    }
  }
`)

const GetSourceByApiKeyQL = gql(`
  query GetSourceByApiKey($input: SourceByApiKeyInput!) {
    sourceByApiKey(input: $input) {
      id
      name
      type
      apiKey
    }
  }
`)

const GetSourceWithLastSeen = gql(`
  query GetSourceWithLastSeen($input: FindByIdInput!) {
    source(input: $input) {
      id
      name
      type
      apiKey
      lastSeen
    }
  }
`)

const CreateSourceQL = gql(`
  mutation CreateSource($input: CreateSourceInput!) {
    createSource(input: $input) {
      id
      name
      type
      apiKey
    }
  }
`)

const UpdateSourceQL = gql(`
  mutation UpdateSource($input: UpdateSourceInput!) {
    updateSource(input: $input) {
      id
      name
      type
      apiKey
    }
  }
`)

export const GetSourcesQuery = () => {
  return useQuery<{ sources: Source[] }>(GetSourcesQL, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })
}

export const GetSourcesLazyQuery = () => {
  return useLazyQuery<{ sources: Source[] }>(GetSourcesQL, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })
}

export const GetSourceQuery = (id?: string) => {
  return useQuery(GetSourceQL, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
    variables: {
      input: {
        id,
      },
    },
    skip: !id,
  })
}

export const GetSourceWithLastSeenLazyQuery = () => {
  return useLazyQuery<{ source: Source }>(GetSourceWithLastSeen, {
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true,
  })
}

export const GetSourceByApiKeyQuery = () => {
  return useLazyQuery<{ sourceByApiKey: Source | null }>(GetSourceByApiKeyQL, {
    fetchPolicy: 'network-only',
  })
}

export const CreateSourceQuery = () => useMutation<{ createSource: Source }>(CreateSourceQL)

export const UpdateSourceQuery = () => useMutation(UpdateSourceQL)
